import React from 'react';
import {Checkbox} from "antd";
import {useSelector} from "react-redux";
import UseSetParams from "./UseSetParams";
import {getFilter} from "../../../store/TableRedux/TableRedux";

const CheckboxFilter = ({data}) => {
    const filter = useSelector((state) => state.TableRedux.filter);
    const [handleSetParams,] = UseSetParams(getFilter)
    const funcHandleSetParams = (newFilter) => {
        handleSetParams(newFilter)
    }
    const {filterName, label} = data
    console.log(filter[filterName])
    return (


        <Checkbox checked={filter[filterName] === "true"} onChange={(e) => {
            funcHandleSetParams([{
                key: filterName, value: e.target.checked
            }])

        }}>{label}</Checkbox>


    );
};

export default CheckboxFilter;